// @ts-nocheck
/* eslint-disable */
/* tslint:disable */
/* prettier-ignore-start */

/** @jsxRuntime classic */
/** @jsx createPlasmicElementProxy */
/** @jsxFrag React.Fragment */

// This class is auto-generated by Plasmic; please do not edit!
// Plasmic Project: 24qDGfvb2rMn6oy8PVF95d
// Component: 4vRjyz8vv6

import * as React from "react";

import * as p from "@plasmicapp/react-web";
import * as ph from "@plasmicapp/react-web/lib/host";

import {
  hasVariant,
  classNames,
  wrapWithClassName,
  createPlasmicElementProxy,
  makeFragment,
  MultiChoiceArg,
  SingleBooleanChoiceArg,
  SingleChoiceArg,
  pick,
  omit,
  useTrigger,
  StrictProps,
  deriveRenderOpts,
  ensureGlobalVariants
} from "@plasmicapp/react-web";

import "@plasmicapp/react-web/lib/plasmic.css";

import plasmic_antd_5_hostless_css from "../antd_5_hostless/plasmic_antd_5_hostless.module.css"; // plasmic-import: ohDidvG9XsCeFumugENU3J/projectcss
import plasmic_plasmic_rich_components_css from "../plasmic_rich_components/plasmic_plasmic_rich_components.module.css"; // plasmic-import: jkU633o1Cz7HrJdwdxhVHk/projectcss
import plasmic_pro_pro_css from "../pro_pro/plasmic_pro_pro.module.css"; // plasmic-import: qtWvXH8Uhh67sc1TY2MZeK/projectcss
import projectcss from "./plasmic_hub_hub.module.css"; // plasmic-import: 24qDGfvb2rMn6oy8PVF95d/projectcss
import sty from "./PlasmicChecklistItem.module.css"; // plasmic-import: 4vRjyz8vv6/css

import ArrowUpload24FilledIcon from "./icons/PlasmicIcon__ArrowUpload24Filled"; // plasmic-import: NEaXmn2yDB/icon
import IconcheckmarkCircleIcon from "./icons/PlasmicIcon__IconcheckmarkCircle"; // plasmic-import: lW-Bgpwrmz/icon
import RadioButtonOffsvgIcon from "./icons/PlasmicIcon__RadioButtonOffsvg"; // plasmic-import: QNWY2y_-7/icon

createPlasmicElementProxy;

export type PlasmicChecklistItem__VariantMembers = {
  hideButton: "hideButton";
  disabled: "disabled";
  done: "done";
};
export type PlasmicChecklistItem__VariantsArgs = {
  hideButton?: SingleBooleanChoiceArg<"hideButton">;
  disabled?: SingleBooleanChoiceArg<"disabled">;
  done?: SingleBooleanChoiceArg<"done">;
};
type VariantPropType = keyof PlasmicChecklistItem__VariantsArgs;
export const PlasmicChecklistItem__VariantProps = new Array<VariantPropType>(
  "hideButton",
  "disabled",
  "done"
);

export type PlasmicChecklistItem__ArgsType = {
  text?: React.ReactNode;
};
type ArgPropType = keyof PlasmicChecklistItem__ArgsType;
export const PlasmicChecklistItem__ArgProps = new Array<ArgPropType>("text");

export type PlasmicChecklistItem__OverridesType = {
  root?: p.Flex<"div">;
  checklistItemContainer?: p.Flex<"div">;
  buttonDefault?: p.Flex<"div">;
  box?: p.Flex<"div">;
  buttonText?: p.Flex<"div">;
  arrowIcon?: p.Flex<"svg">;
};

export interface DefaultChecklistItemProps {
  text?: React.ReactNode;
  hideButton?: SingleBooleanChoiceArg<"hideButton">;
  disabled?: SingleBooleanChoiceArg<"disabled">;
  done?: SingleBooleanChoiceArg<"done">;
  className?: string;
}

const $$ = {};

function PlasmicChecklistItem__RenderFunc(props: {
  variants: PlasmicChecklistItem__VariantsArgs;
  args: PlasmicChecklistItem__ArgsType;
  overrides: PlasmicChecklistItem__OverridesType;
  forNode?: string;
}) {
  const { variants, overrides, forNode } = props;

  const args = React.useMemo(() => Object.assign({}, props.args), [props.args]);

  const $props = {
    ...args,
    ...variants
  };

  const $ctx = ph.useDataEnv?.() || {};
  const refsRef = React.useRef({});
  const $refs = refsRef.current;

  const currentUser = p.useCurrentUser?.() || {};

  const stateSpecs: Parameters<typeof p.useDollarState>[0] = React.useMemo(
    () => [
      {
        path: "hideButton",
        type: "private",
        variableType: "variant",
        initFunc: ({ $props, $state, $queries, $ctx }) => $props.hideButton
      },
      {
        path: "disabled",
        type: "private",
        variableType: "variant",
        initFunc: ({ $props, $state, $queries, $ctx }) => $props.disabled
      },
      {
        path: "done",
        type: "private",
        variableType: "variant",
        initFunc: ({ $props, $state, $queries, $ctx }) => $props.done
      }
    ],
    [$props, $ctx, $refs]
  );
  const $state = p.useDollarState(stateSpecs, {
    $props,
    $ctx,
    $queries: {},
    $refs
  });

  return (
    <div
      data-plasmic-name={"root"}
      data-plasmic-override={overrides.root}
      data-plasmic-root={true}
      data-plasmic-for-node={forNode}
      className={classNames(
        projectcss.all,
        projectcss.root_reset,
        projectcss.plasmic_default_styles,
        projectcss.plasmic_mixins,
        projectcss.plasmic_tokens,
        plasmic_antd_5_hostless_css.plasmic_tokens,
        plasmic_plasmic_rich_components_css.plasmic_tokens,
        plasmic_pro_pro_css.plasmic_tokens,
        sty.root,
        { [sty.rootdone]: hasVariant($state, "done", "done") }
      )}
    >
      <div
        data-plasmic-name={"checklistItemContainer"}
        data-plasmic-override={overrides.checklistItemContainer}
        className={classNames(projectcss.all, sty.checklistItemContainer, {
          [sty.checklistItemContainerdisabled]: hasVariant(
            $state,
            "disabled",
            "disabled"
          ),
          [sty.checklistItemContainerdone]: hasVariant($state, "done", "done"),
          [sty.checklistItemContainerhideButton]: hasVariant(
            $state,
            "hideButton",
            "hideButton"
          )
        })}
      >
        <div
          className={classNames(projectcss.all, sty.freeBox__yBgv, {
            [sty.freeBoxdisabled__yBgvcfQ5]: hasVariant(
              $state,
              "disabled",
              "disabled"
            ),
            [sty.freeBoxdone__yBgv1KLpF]: hasVariant($state, "done", "done"),
            [sty.freeBoxhideButton__yBgvcAek8]: hasVariant(
              $state,
              "hideButton",
              "hideButton"
            )
          })}
        >
          {p.renderPlasmicSlot({
            defaultContents: (
              <div
                className={classNames(
                  projectcss.all,
                  projectcss.__wab_text,
                  sty.text__ucWnh
                )}
              >
                <React.Fragment>
                  <React.Fragment>{"create a new "}</React.Fragment>
                  <span
                    className={"plasmic_default__all plasmic_default__span"}
                    style={{ fontStyle: "italic" }}
                  >
                    {"Section"}
                  </span>
                </React.Fragment>
              </div>
            ),
            value: args.text,
            className: classNames(sty.slotTargetText, {
              [sty.slotTargetTextdisabled]: hasVariant(
                $state,
                "disabled",
                "disabled"
              ),
              [sty.slotTargetTextdone]: hasVariant($state, "done", "done"),
              [sty.slotTargetTexthideButton]: hasVariant(
                $state,
                "hideButton",
                "hideButton"
              )
            })
          })}
        </div>
        {(
          hasVariant($state, "done", "done")
            ? false
            : hasVariant($state, "disabled", "disabled")
            ? false
            : hasVariant($state, "hideButton", "hideButton")
            ? false
            : true
        ) ? (
          <p.Stack
            as={"div"}
            data-plasmic-name={"buttonDefault"}
            data-plasmic-override={overrides.buttonDefault}
            hasGap={true}
            className={classNames(projectcss.all, sty.buttonDefault, {
              [sty.buttonDefaultdisabled]: hasVariant(
                $state,
                "disabled",
                "disabled"
              ),
              [sty.buttonDefaultdone]: hasVariant($state, "done", "done"),
              [sty.buttonDefaulthideButton]: hasVariant(
                $state,
                "hideButton",
                "hideButton"
              )
            })}
          >
            <div
              data-plasmic-name={"box"}
              data-plasmic-override={overrides.box}
              className={classNames(projectcss.all, sty.box, {
                [sty.boxdisabled]: hasVariant($state, "disabled", "disabled"),
                [sty.boxdone]: hasVariant($state, "done", "done")
              })}
            >
              <div
                data-plasmic-name={"buttonText"}
                data-plasmic-override={overrides.buttonText}
                className={classNames(
                  projectcss.all,
                  projectcss.__wab_text,
                  sty.buttonText,
                  {
                    [sty.buttonTextdisabled]: hasVariant(
                      $state,
                      "disabled",
                      "disabled"
                    ),
                    [sty.buttonTextdone]: hasVariant($state, "done", "done")
                  }
                )}
              >
                {"Go  "}
              </div>
            </div>
            <div className={classNames(projectcss.all, sty.freeBox__z3LVu)}>
              <ArrowUpload24FilledIcon
                data-plasmic-name={"arrowIcon"}
                data-plasmic-override={overrides.arrowIcon}
                className={classNames(projectcss.all, sty.arrowIcon, {
                  [sty.arrowIconhideButton]: hasVariant(
                    $state,
                    "hideButton",
                    "hideButton"
                  )
                })}
                role={"img"}
              />
            </div>
          </p.Stack>
        ) : null}
        {(hasVariant($state, "done", "done") ? true : false) ? (
          <IconcheckmarkCircleIcon
            className={classNames(projectcss.all, sty.svg__iq43T, {
              [sty.svgdone__iq43T1KLpF]: hasVariant($state, "done", "done")
            })}
            role={"img"}
          />
        ) : null}
        {(hasVariant($state, "done", "done") ? true : false) ? (
          <RadioButtonOffsvgIcon
            className={classNames(projectcss.all, sty.svg__bPTiC, {
              [sty.svgdisabled__bPTiCcfQ5]: hasVariant(
                $state,
                "disabled",
                "disabled"
              ),
              [sty.svgdone__bPTiC1KLpF]: hasVariant($state, "done", "done"),
              [sty.svghideButton__bPTiCcAek8]: hasVariant(
                $state,
                "hideButton",
                "hideButton"
              )
            })}
            role={"img"}
          />
        ) : null}
      </div>
      {(hasVariant($state, "done", "done") ? false : false) ? (
        <div
          className={classNames(projectcss.all, sty.freeBox___3Xg0Z, {
            [sty.freeBoxdone___3Xg0Z1KLpF]: hasVariant($state, "done", "done")
          })}
        />
      ) : null}
      {(hasVariant($state, "done", "done") ? true : false) ? (
        <div
          className={classNames(projectcss.all, sty.freeBox__nn6Nm, {
            [sty.freeBoxdone__nn6Nm1KLpF]: hasVariant($state, "done", "done")
          })}
        />
      ) : null}
    </div>
  ) as React.ReactElement | null;
}

const PlasmicDescendants = {
  root: [
    "root",
    "checklistItemContainer",
    "buttonDefault",
    "box",
    "buttonText",
    "arrowIcon"
  ],
  checklistItemContainer: [
    "checklistItemContainer",
    "buttonDefault",
    "box",
    "buttonText",
    "arrowIcon"
  ],
  buttonDefault: ["buttonDefault", "box", "buttonText", "arrowIcon"],
  box: ["box", "buttonText"],
  buttonText: ["buttonText"],
  arrowIcon: ["arrowIcon"]
} as const;
type NodeNameType = keyof typeof PlasmicDescendants;
type DescendantsType<T extends NodeNameType> =
  (typeof PlasmicDescendants)[T][number];
type NodeDefaultElementType = {
  root: "div";
  checklistItemContainer: "div";
  buttonDefault: "div";
  box: "div";
  buttonText: "div";
  arrowIcon: "svg";
};

type ReservedPropsType = "variants" | "args" | "overrides";
type NodeOverridesType<T extends NodeNameType> = Pick<
  PlasmicChecklistItem__OverridesType,
  DescendantsType<T>
>;
type NodeComponentProps<T extends NodeNameType> =
  // Explicitly specify variants, args, and overrides as objects
  {
    variants?: PlasmicChecklistItem__VariantsArgs;
    args?: PlasmicChecklistItem__ArgsType;
    overrides?: NodeOverridesType<T>;
  } & Omit<PlasmicChecklistItem__VariantsArgs, ReservedPropsType> & // Specify variants directly as props
    /* Specify args directly as props*/ Omit<
      PlasmicChecklistItem__ArgsType,
      ReservedPropsType
    > &
    /* Specify overrides for each element directly as props*/ Omit<
      NodeOverridesType<T>,
      ReservedPropsType | VariantPropType | ArgPropType
    > &
    /* Specify props for the root element*/ Omit<
      Partial<React.ComponentProps<NodeDefaultElementType[T]>>,
      ReservedPropsType | VariantPropType | ArgPropType | DescendantsType<T>
    >;

function makeNodeComponent<NodeName extends NodeNameType>(nodeName: NodeName) {
  type PropsType = NodeComponentProps<NodeName> & { key?: React.Key };
  const func = function <T extends PropsType>(
    props: T & StrictProps<T, PropsType>
  ) {
    const { variants, args, overrides } = React.useMemo(
      () =>
        deriveRenderOpts(props, {
          name: nodeName,
          descendantNames: PlasmicDescendants[nodeName],
          internalArgPropNames: PlasmicChecklistItem__ArgProps,
          internalVariantPropNames: PlasmicChecklistItem__VariantProps
        }),
      [props, nodeName]
    );
    return PlasmicChecklistItem__RenderFunc({
      variants,
      args,
      overrides,
      forNode: nodeName
    });
  };
  if (nodeName === "root") {
    func.displayName = "PlasmicChecklistItem";
  } else {
    func.displayName = `PlasmicChecklistItem.${nodeName}`;
  }
  return func;
}

export const PlasmicChecklistItem = Object.assign(
  // Top-level PlasmicChecklistItem renders the root element
  makeNodeComponent("root"),
  {
    // Helper components rendering sub-elements
    checklistItemContainer: makeNodeComponent("checklistItemContainer"),
    buttonDefault: makeNodeComponent("buttonDefault"),
    box: makeNodeComponent("box"),
    buttonText: makeNodeComponent("buttonText"),
    arrowIcon: makeNodeComponent("arrowIcon"),

    // Metadata about props expected for PlasmicChecklistItem
    internalVariantProps: PlasmicChecklistItem__VariantProps,
    internalArgProps: PlasmicChecklistItem__ArgProps
  }
);

export default PlasmicChecklistItem;
/* prettier-ignore-end */
